export default __webpack_public_path__ + "static/media/NoImage.27ff265d.png";